import React from "react";
import Map from "./Map.js";
import Panel from "./Panel.js";
import * as Leaflet from "react-leaflet";
import { Information } from "react-ionicons";

export default function Body(params) {
    return (
        <section className="body">
            <Map
                changeStateData={params.changeStateData}
                stateData={params.stateData}
            />
            <Panel
                changeStateData={params.changeStateData}
                stateData={params.stateData}
            />
        </section>
    );
}
